import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "Fire Alarm Blueprint Trainer";
const DEFAULT_DESC =
  "Fire alarm training and fire alarm system design practice. Lay out NFPA 72 devices on interactive blueprints, learn placement and circuitry, and study for fire alarm inspections — an educational trainer for technicians, designers, and students.";
const DEFAULT_KEYWORDS =
  "fire alarm training, fire alarm system design, NFPA 72, fire alarm technician, fire alarm layout, fire alarm blueprint, fire alarm inspection, smoke detector placement";
const DEFAULT_IMAGE = "https://firealarmbt.com/og-image.jpg";

export default function Seo({ title, description, path, image, imageAlt, keywords, type = "website", noindex = false, jsonLd, alternates, lang }) {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const pathname = path || (typeof window !== "undefined" ? window.location.pathname : "/");
  const url = origin + pathname;
  const fullTitle = title ? `${title} | ${SITE}` : `${SITE} — Learn Fire Alarm System Design`;
  const desc = description || DEFAULT_DESC;
  const img = image || (origin ? `${origin}/og-image.jpg` : DEFAULT_IMAGE);

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="keywords" content={keywords || DEFAULT_KEYWORDS} />
      {noindex ? <meta name="robots" content="noindex, nofollow" /> : <meta name="robots" content="index, follow" />}
      <link rel="canonical" href={url} />
      <html lang={lang || "en"} />
      {(alternates || []).map((a) => <link key={a.lang} rel="alternate" hrefLang={a.lang} href={origin + a.href} />)}

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      {imageAlt && <meta property="og:image:alt" content={imageAlt} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {imageAlt && <meta name="twitter:image:alt" content={imageAlt} />}

      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
